import { HomePrefs } from '../components/interfaces';
import axios, { API_BASE, handler } from './http-service';

const baseURL = `${API_BASE}/prefs`;

export const getPrefs = () => {
  return handler(() => axios.get(baseURL));
}

export const getHomePrefs = () => {
  const url = `${baseURL}/home`;
  return handler(() => axios.get(url));
}

export const updateHomePrefs = (data: HomePrefs) => {
  const url = `${baseURL}/home`;
  return handler(() => axios.put(url, data));
}


const prefService = {
  getPrefs,
  getHomePrefs,
  updateHomePrefs,
}

export default prefService;
